// extracted by mini-css-extract-plugin
module.exports = {"product-card-carousel":"ProductCardCarousel_product-card-carousel__9iyEU","product-card-carousel--ready":"ProductCardCarousel_product-card-carousel--ready__l0HS0"};